import {
  CognitoUserPool,
  CognitoUser,
} from 'amazon-cognito-identity-js';

const poolData = {
  UserPoolId : process.env.REACT_APP_COGNITO_POOL_ID,
  ClientId   : process.env.REACT_APP_COGNITO_WEB_CLIENT_ID,
};
const userPool = new CognitoUserPool(poolData);

const clearOldSession = async function clearOldSession(loggedInData) {
  // more info can be found here https://www.npmjs.com/package/amazon-cognito-identity-js

  const existingCognitoUser = userPool.getCurrentUser();

  if (existingCognitoUser != null) {
    const existingSession = await new Promise((resolve) => {
      existingCognitoUser.getSession((err, session) => resolve(session));
    });

    if (existingSession != null) {
      await new Promise((onSuccess) => {
        existingCognitoUser.globalSignOut({ // invalidate against cognito
          onSuccess,
          onFailure: () => {
            // global signout falied (potentially already expired session), remove local creds
            existingCognitoUser.signOut();
            onSuccess();
          },
        });
      });
    } else {
      // no valid session (e.g. refresh/access token already expired) — globalSignOut can't run
      existingCognitoUser.signOut();
    }
  }

  return loggedInData;
};

const loginUserViaSessionData = async function loginUserViaSessionData(loggedInData) {
  const userData = {
    Username : loggedInData.username,
    Pool     : userPool,
  };
  const cognitoUser = new CognitoUser(userData);

  cognitoUser.setSignInUserSession(cognitoUser.getCognitoUserSession(loggedInData.session));

  return loggedInData;
};

export {
  clearOldSession,
  loginUserViaSessionData,
};
